<!-- if the user is online -->
@if (isConnected) {
  <!-- show the loader if the 'loading' is true' -->
  <!-- <div class="overlay"> -->
  @if (loading) {
    <div class="loader"></div>
  }
  <!-- <div class="loading" *ngIf="loading">Loading&#8230;</div> -->
<!-- </div> -->
@if (showToaster) {
  <div class="toaster">
    <div class="row">
      <div class="col-md-12 bar">
        <div class="progress-bar" [ngStyle]="{
            'background-color': successMessage
              ? '#3e97ff'
              : errorMessage
              ? '#ff4b55'
              : ''
          }"></div>
      </div>
    </div>
    <div class="second">
      <div>
        @if (successMessage) {
          <img style="width: 35px" src="../assets/images/check-circle.svg" class="cursor-pointer close" alt=""
            />
        }
        @if (errorMessage) {
          <img style="width: 35px" src="../assets/images/close-cross.svg" class="cursor-pointer close" alt=""
            />
        }
      </div>
      <div class="message">
        {{ successMessage ? successMessage : errorMessage }}
      </div>
      <div class="closeImg">
        <img src="../assets/images/close-svgrepo-com.svg" (click)="closeToaster()" class="cursor-pointer close"
          alt="" />
        </div>
      </div>
    </div>
  }
  <router-outlet></router-outlet>
} @else {
  <div class="no-internet-section">
    <div class="message row no-gutter">
      <div class="col-sm-12 text-center">
        <!-- <img class="no-internet-logo" src="assets/images/no-internet.png" /><br> -->
        <h2 class="title">No Internet Connection</h2>
        <h3 class="sub-title">Your connection appears to be off-line.</h3>
      </div>
    </div>
  </div>
}
<!-- if the user is offline -->
